export class Group {
  id: number;
  groupCode: string;
  groupName: string;
  isAdmin: boolean;
  isActivity: boolean;
  disEducationAndTrainingFor: number;
  checked: boolean;
  schoolNumber: number;
  total: number;
  constructor() {
    this.disEducationAndTrainingFor = 1;
    this.isAdmin = true;
    this.isActivity = true;
    this.schoolNumber = 0;
  }
}
